//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import { HolidaysList } from '@/views/HumanResource/HrHoliday'

//
export default {
    path: 'holidays',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'holidays-list',
            component: HolidaysList,
        },
    ],
    meta: {
        title: 'Vacaciones',
    },
}
